var Utils      = require('Utils'),
    ol         = require("openlayers"),
    Collection = require("Collection"),
    VLayer      = require("./VectorLayer"),
    PLayer = require("../Project/Layer");

var Choropleth = VLayer.extend({

    options: {
        totalColors : 10,
        minFillColor: '#ffffff',
        maxFillColor: '#000000',
        strokeColor : '#ffffff',
        strokeWidth : 1,
        radius: 5
    },

    initialize: function(Layer, options){
        var that = this;
        if(!(Layer instanceof PLayer)){
            throw new Error('`Layer` is not instance of omjs.Project.Layer')
        }

        if(!Layer.objects.getLength()){
            throw new Error('`Layer` has no objects')
        }

        that.setOptions(options);

        that._olSource = new ol.source.Vector();
        that._olLayer = new ol.layer.Vector();
        that._olLayer.set('omjsLayer', that);

        that.setSource(that._olSource);

        that._projectLayer = Layer;
        that._classificators = null;

        that._fillFeatures();
    },

    setField: function(fieldCode){

        var that = this;
        that.options.field = fieldCode;

        that.bindData(that._projectLayer.objects, function(data, pobject){
            return pobject.get(that.options.field)
        });

        that.classify(that._createClassificators());

        return that;
    },

    _createClassificators: function(){
        var that = this,
            maxVal,
            minVal,
            delta,
            classificators = [],
            colors;

        var values = that._projectLayer.objects.pluck(that.options.field).map(function(v){
            return parseFloat(v)
        });

        if(!values.length){
            throw new Error('Object field `' + that.options.field + '` value not found')
        }

        maxVal = Math.max.apply(window, values);
        minVal = Math.min.apply(window, values);
        delta = (maxVal-minVal) / that.options.totalColors;

        colors = Utils.generateColors(that.options.minFillColor, that.options.maxFillColor, that.options.totalColors);

        colors.forEach(function(color, index){
            var classificator = {
                name: index+'',
                index: index,
                _min: 0,
                _max: 0,
                style: new ol.style.Style({
                    image: new ol.style.Circle({
                        radius: that.options.radius,
                        stroke: new omjs.ol.style.Stroke({
                            color: that.options.strokeColor,
                            width: that.options.strokeWidth
                        }),
                        fill: new ol.style.Fill({
                            color: color
                        })
                    })
                }),
                legendData:{
                    name: (delta*index) + " - " + (delta*index + delta),
                    fillColor: color,
                    strokeColor: that.options.strokeColor,
                    strokeWidth: that.options.strokeWidth
                }
            };

            classificator.matcher = function(value){
                var classificator = this,
                    calculatedIndex;

                calculatedIndex = parseInt((value - minVal) / delta);
                return calculatedIndex == classificator.index || (classificator.index == that.options.totalColors - 1 && calculatedIndex > classificator.index);
            };

            classificator.matcher.bind(classificator);
            classificators.push(classificator);
        });

        return classificators;
    },

    _fillFeatures: function(){
        var that = this;
        var features = [];
        that._projectLayer.objects.each(function(obj){
            var geom = obj.getGeometry();

            if(geom.type in ol.geom){
                var feature = new ol.Feature({
                    obj     : obj,
                    geometry: new ol.geom[geom.type](geom.coordinates)
                });
                feature.setId(obj.id);
                features.push(feature);
            }else{
                console.warn('Unknown geometry type', obj, geom.type)
            }
        });
        that._olSource.addFeatures(features);
    },

    classify: function(classificators){
        var that = this;
        if(classificators!= undefined){
            that._classificators = new Collection(classificators);
        }

        that._classificators.each(function(classificator){
            that._olSource.forEachFeature(function(feature){
                var obj = feature.get('obj');
                if(classificator.matcher(that._getValue(that._data, obj, feature, that._projectLayer), obj, feature)){
                    feature.setStyle(classificator.style);
                }
            })
        })
    },

    /**
     * @param data любые данные
     * @param matcher функция, в которую будет передан data и feature. Нужно вернуть значение
     */
    bindData: function(data, matcher){
        var that = this;

        that._data = data;
        that._getValue = matcher;

        return that;
    },

    /**
     *
     */
    show: function(){
        var that = this;
        that['_olLayer'] !== undefined
            ? that['_olLayer'].setVisible(true)
            : $.noop();
    },

    /**
     *
     */
    hide: function(){
        var that = this;
        that['_olLayer'] !== undefined
            ? that['_olLayer'].setVisible(false)
            : $.noop();
    },

    /**
     *
     */
    toggle: function(){
        var that = this;
        that._olLayer.getVisible() ? that.hide() : that.show();
    },

    /**
     *
     */
    isVisible: function(){
        var that = this;
        return that['_olLayer'] !== undefined ? that['_olLayer'].getVisible() : false;
    },

    /**
     *
     */
    getMapLayer: function(){
        return this._olLayer;
    },

    getProjectLayers: function(){
        return this._projectLayer;
    },

    /**
     *
     */
    setMapLayer: function(layer){
        var that = this;
        that._olLayer = layer;
    },

    /**
     *
     */
    setSource: function(source){
        var that = this;
        that._olLayer.setSource(source);
    },

    setStyle: function(style){
        var that = this;
        that._olLayer.setStyle(style);
    },

    getLegendData: function(){
        var that = this;

        return that._classificators.getArray().map(function(cls){
            return cls.legendData;
        });
    }
});

module.exports = Choropleth;


//////////////////
// WEBPACK FOOTER
// ./src/View/Choropleth.js
// module id = 245
// module chunks = 0